var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./pages/default/artists/artists.module": [
		"./src/app/theme/pages/default/artists/artists.module.ts",
		"artists.module"
	],
	"./pages/default/bookings/bookings.module": [
		"./src/app/theme/pages/default/bookings/bookings.module.ts",
		"bookings.module"
	],
	"./pages/default/calendar/calendar.module": [
		"./src/app/theme/pages/default/calendar/calendar.module.ts",
		"common",
		"calendar.module"
	],
	"./pages/default/contacts/contacts.module": [
		"./src/app/theme/pages/default/contacts/contacts.module.ts",
		"common",
		"contacts.module"
	],
	"./pages/default/dashboard/dashboard.module": [
		"./src/app/theme/pages/default/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./pages/default/editArtist/editArtist.module": [
		"./src/app/theme/pages/default/editArtist/editArtist.module.ts",
		"common",
		"editArtist.module"
	],
	"./pages/default/editBooking/editBooking.module": [
		"./src/app/theme/pages/default/editBooking/editBooking.module.ts",
		"common",
		"editBooking.module"
	],
	"./pages/default/profile/profile.module": [
		"./src/app/theme/pages/default/profile/profile.module.ts",
		"profile.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main